<template>
  <VForm @submit.prevent="save">
    <VRow no-gutters>
      <VCol cols="12">
        <v-select
          v-model="locale"
          :items="languages"
          :label="$t('language')"
          dense
          outlined
          :error-messages="errors.locale"
        />
      </VCol>
    </VRow>
    <VRow justify="center" no-gutters>
      <VCol
        v-if="hasErrorMessageOnly"
        cols="12"
        md="6"
        class="red--text text-center mb-6"
      >
        {{ errorMessage }}
      </VCol>
      <VCol cols="12" class="text-center">
        <VBtn
          color="success"
          dark
          elevation="0"
          type="submit"
          :loading="loading"
        >
          {{ $t('save') }}
        </VBtn>
      </VCol>
    </VRow>
  </VForm>
</template>

<script>
import Company from '@/orm/models/Company/Company';
import ValidationMixin from '../mixins/ValidationMixin';
import { localeType } from '../enums';
import UserSettings from '../orm/models/User/Settings';
import Locale from '../locale';

export default {
  name: 'UserSettingsForm',
  mixins: [ValidationMixin],
  data() {
    return {
      locale: this.$i18n.locale,
      languages: [
        { text: 'English', value: localeType.EN },
        { text: 'Русский', value: localeType.RU },
      ],
      loading: false,
    };
  },
  methods: {
    async save() {
      await this.withValidationHandling(async () => {
        await UserSettings.api().update({
          locale: this.locale,
        });
        Locale.change(this.locale);
        await Company.api().fetch();
        this.$toast.success(this.$t('settingsChanged'));
      });
    },
  },
};
</script>

<i18n locale="en" lang="yaml">
  language: Language
  save: Save
  settingsChanged: Settings changed
</i18n>

<i18n locale="ru" lang="yaml">
  language: Язык
  save: Сохранить
  settingsChanged: Настройки сохранены
</i18n>
